import { logWrapper } from '../../utils';

export default {
  adminController: [
    'runtimeConstant',
    '$scope',
    '$controller',
    function (runtimeConstant, $scope, $controller) {
      'use strict';

      function run() {
        try {
          $controller('baseHomeController', { $scope: $scope });

          $scope.disableSearch = true;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
